import asObject from 'utils/objects/asObject.util';

import {
  HIDE_NON_WORKING_STYLIST_COLUMN_FAILURE,
  HIDE_NON_WORKING_STYLIST_COLUMN_REQUEST,
  HIDE_NON_WORKING_STYLIST_COLUMN_SUCCESS,
  RESTORE_SERVER_DATA,
  SET_SAVED_FALSE,
  TOGGLE_DEPOSIT_PROMPT_FAILURE,
  TOGGLE_DEPOSIT_PROMPT_REQUEST,
  TOGGLE_DEPOSIT_PROMPT_SUCCESS,
  UPDATE_NO_SHOW_BEHAVIOUR_FAILURE,
  UPDATE_NO_SHOW_BEHAVIOUR_REQUEST,
  UPDATE_NO_SHOW_BEHAVIOUR_SUCCESS,
} from 'settings/noshowvisibility/actions';

const noShowVisibilityReducer = (
  state = {
    isFetching: false,
    errorMessage: '',
    noShowBehaviourIsSaved: false,
  },
  action,
) => {
  const { type, response } = asObject(action);

  if (!type) return state;

  const { noshow_behaviour: noShowBehaviour, error } = asObject(response);

  switch (type) {
    case RESTORE_SERVER_DATA:
      return { ...state };
    case UPDATE_NO_SHOW_BEHAVIOUR_REQUEST:
      return { isFetching: true, errorMessage: '', noShowBehaviourIsSaved: false };
    case UPDATE_NO_SHOW_BEHAVIOUR_SUCCESS:
      return { noshow_behaviour: noShowBehaviour, noShowBehaviourIsSaved: true, isFetching: false, errorMessage: '' };
    case UPDATE_NO_SHOW_BEHAVIOUR_FAILURE:
      return { isFetching: false, errorMessage: error.errorMessage, noShowBehaviourIsSaved: false };
    case SET_SAVED_FALSE:
      return { errorMessage: '', noShowBehaviourIsSaved: false };
    case HIDE_NON_WORKING_STYLIST_COLUMN_REQUEST:
      return { ...state, isFetching: true };
    case HIDE_NON_WORKING_STYLIST_COLUMN_SUCCESS:
      return { ...state, isFetching: false };
    case HIDE_NON_WORKING_STYLIST_COLUMN_FAILURE:
      return { ...state };
    case TOGGLE_DEPOSIT_PROMPT_REQUEST:
      return { ...state, isFetching: true };
    case TOGGLE_DEPOSIT_PROMPT_SUCCESS:
      return { ...state, isFetching: false };
    case TOGGLE_DEPOSIT_PROMPT_FAILURE:
      return { ...state };
    default:
      return state;
  }
};

export default noShowVisibilityReducer;
